import { render } from "./MyViewHistory.vue?vue&type=template&id=39e4d1f4"
import script from "./MyViewHistory.vue?vue&type=script&lang=js"
export * from "./MyViewHistory.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__